import { render } from "./DealsView.vue?vue&type=template&id=6af9cc56"
import script from "./DealsView.vue?vue&type=script&lang=js"
export * from "./DealsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__